import { useQueryClient } from '@tanstack/vue-query';
import type { RouteRecordRaw } from 'vue-router';

import { type Profile, profileKeys } from '@/entities/profile';
import { teamQueryOptions } from '@/entities/team';

export default {
  path: '/teams/:uuid',
  component: () => import('@/views/dashboard/teams/team/root.vue'),
  children: [
    {
      path: '',
      name: 'team',
      component: () => import('@/views/dashboard/teams/team/team.vue'),
    },
    {
      path: 'settings',
      name: 'team/settings',
      beforeEnter: async (to) => {
        const queryClient = useQueryClient();

        const team = await queryClient.ensureQueryData(teamQueryOptions(to.params.uuid as string));
        const profile = queryClient.getQueryData<Profile>(profileKeys.profile());

        if (profile?.uuid !== team?.owner_uuid) {
          return { name: '404' };
        }
      },
      component: () => import('@/views/dashboard/teams/team/settings.vue'),
    },
  ],
} satisfies RouteRecordRaw;
